// extracted by mini-css-extract-plugin
export var sliderRange = "_r2-2";
export var sliderRoot = "_r2-0";
export var sliderThumb = "_r2-3";
export var sliderTrack = "_r2-1";